import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccountComponentsModule } from '@draeger-academy/presentation/lib/modules/account/account.module';
import { DetailViewModule } from '@draeger-academy/presentation/lib/modules/detail-view';
import { BookingModule } from '../lib/modules/booking-steps/booking-steps.module';
import { CourseListModule } from '../lib/modules/course-list/course-list.module';
import { BreadcrumbModule } from '../lib/modules/breadcrumb';
import { FooterModule } from '../lib/modules/footer';
import { HeaderModule } from '../lib/modules/header';
import { HubspotModule } from '../lib/modules/hubspot';
import { HubspotFormBoxModule } from '../lib/modules/hubspot-form-box';
import { CourseTeaserModule } from '../lib/modules/course-teaser';
import { MediaTeaserBoxModule } from '../lib/modules/media-teaser-box';
import { SiteNavigationModule } from '../lib/modules/site-navigation';
import { VideoModule } from '../lib/modules/video/video.module';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionBoxModule } from './modules/accordion-box';
import { ContactUsSectionModule } from './modules/contact-us-section';
import { ContentSectionModule } from './modules/content-section';
import { CourseItemModule } from './modules/course-item/course-item.module';
import { MyCourseItemModule } from './modules/my-course-item/my-course-item.module';
import { InfoPackageModule } from './modules/info-package/info-package.module';
import { DaButtonModule } from './modules/da-button/da-button.module';

import { DaLinkModule } from './modules/da-link/da-link.module';
import { DaProgressiveImageModule } from './modules/da-progressive-image/da-progressive-image.module';
import { FilteringModule } from './modules/filtering/filtering.module';

import { FormBuilderModule } from './modules/form-builder/form-builder.module';
import { GlobalNotificationModule } from './modules/globalnotification/global-notification.module';
import { LinkListBoxModule } from './modules/link-list-box';
import { PaginationModule } from './modules/pagination/pagination.module';

import { ShowMoreModule } from './modules/show-more/show-more.module';
import { SingleStageModule } from './modules/single-stage/single-stage.module';
import { SmallImageBoxModule } from './modules/small-image-box';
import { TabSectionModule } from './modules/tab-section/tab-section.module';
import { TeaserBoxContainerModule } from './modules/teaser-boxes-container/teaser-box-container.module';
import { TeaserCardBoxModule } from './modules/teaser-card-box';
import { GenericModalModule } from './modules/generic-modal';

import { TooltipModule } from './modules/tooltip/tooltip.module';
import { LanguageCountrySwitcherModule } from './modules/language-country-switcher/language-country-switcher.module';
import { CountrySwitcherModule } from './modules/country-switcher/country-switcher.module';
import { LoginModule } from './modules/login/login.module';
import { CartModule } from './modules/cart/cart.module';
import { CouponCodeModule } from './modules/coupon-code/coupon-code.module';
import { LoginFormModule } from './modules/login-form/login-form.module';
import { LogoutModule } from './modules/logout';
import { MyAccountModule } from './modules/my-account';
import { PersonalDataFormModule } from './modules/personal-data-form/personal-data-form.module';
import { CatalogListModule } from './modules/catalog-list';
import { CatalogItemModule } from './modules/catalog-item';
import { CheckoutListModule } from './modules/checkout-list/checkout-list.module';
import { CheckoutListEventPriceModule } from './modules/checkout-list-event-price/checkout-list-event-price.module';
import { PersonFormModule } from './modules/person-form';
import { HotelsListModule } from './modules/hotels-list/hotels-list.module';
import { HotelModule } from './modules/hotels-list/hotel/hotel.module';
import { PersonCardModule } from './modules/person-card';
import { HotelsModule } from './modules/hotels';
import { EventsModule } from './modules/events/events.module';
import { AutoCompleteSearchV3Module } from './modules/auto-complete-search/auto-complete-search-v3.module';
import { AcsInputModule } from './modules/acs-input';
import { CookieConsentOverlayModule } from './modules/cookie-consent-overlay/cookie-consent-overlay.module';
import { CookieReplacementModule } from './modules/cookie-replacement/cookie-replacement.module';
import { SearchItemModule } from './modules/search-item/search-item.module';
const MODULES = [
    DaButtonModule,
    DaLinkModule,
    GlobalNotificationModule,
    ShowMoreModule,
    PaginationModule,
    TooltipModule,
    FormBuilderModule,
    ContentSectionModule,
    ContactUsSectionModule,
    TabSectionModule,
    SmallImageBoxModule,
    TeaserCardBoxModule,
    HeaderModule,
    BreadcrumbModule,
    SiteNavigationModule,
    MediaTeaserBoxModule,
    FooterModule,
    VideoModule,
    CourseTeaserModule,
    HubspotFormBoxModule,
    HubspotModule,
    TeaserBoxContainerModule,
    FilteringModule,
    CourseItemModule,
    SingleStageModule,
    DaProgressiveImageModule,
    LinkListBoxModule,
    AccordionBoxModule,
    GenericModalModule,
    CountrySwitcherModule,
    LanguageCountrySwitcherModule,
    LoginModule,
    LoginFormModule,
    LogoutModule,
    CartModule,
    CouponCodeModule,
    MyAccountModule,
    PersonalDataFormModule,
    CatalogListModule,
    CatalogItemModule,
    CheckoutListModule,
    CheckoutListEventPriceModule,
    PersonFormModule,
    MyCourseItemModule,
    InfoPackageModule,
    PersonCardModule,
    HotelsListModule,
    HotelModule,
    HotelsModule,
    EventsModule,
    CourseListModule,
    BookingModule,
    DetailViewModule,
    AccountComponentsModule,
    AutoCompleteSearchV3Module,
    AcsInputModule,
    CookieConsentOverlayModule,
    CookieReplacementModule,
    SearchItemModule,
    TranslateModule.forChild(),
    LocalizeRouterModule.forChild([])
];
const DECLARATIONS = [];
const MODULE_PROVIDERS = [];

@NgModule({
    imports: [...MODULES],
    declarations: [...DECLARATIONS],
    exports: [...DECLARATIONS, ...MODULES]
})
export class AcademyPresentationUiModule {
    static forRoot(): ModuleWithProviders<AcademyPresentationUiModule> {
        return {
            ngModule: AcademyPresentationUiModule,
            providers: [...MODULE_PROVIDERS]
        };
    }
}
